import {Component, OnInit} from '@angular/core';
import {UserSearchCity} from '@models/search';
import {AdService} from '@services/ad.service';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';
import {Router} from '@angular/router';
import {SEARCH_CITY_PARAMS} from '@models/empty';
import {AlertService} from '@services/alert.service';
import {TutoComponent} from '@components/popup/tuto/tuto.component';
import {MatDialog} from '@angular/material/dialog';
import {OnboardingService} from '@services/onboarding.service';

@Component({
    selector: 'app-select-city',
    templateUrl: './select-city.component.html',
    styleUrls: ['./select-city.component.scss']
})
export class SelectCityComponent implements OnInit {

    userSearch: UserSearchCity;
    userSearchs: UserSearchCity[] = [];

    constructor(
        private adService: AdService,
        private userService: UserService,
        private alertService: AlertService,
        private onboardingService: OnboardingService,
        public authenticationService: AuthenticationService,
        private router: Router,
        public dialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        if (this.authenticationService.isLogin) {
            this.adService.getUserSearchCity().subscribe(r => {
                if (this.authenticationService.isAllowed('essentiel')) {
                    this.userSearchs = r;
                }
                if (r.length == 0) {
                    this.router.navigate(['/app/city/result/filters']);
                } else if (this.authenticationService.currentUser.user_onboarding.auto && this.authenticationService.currentUser.user_onboarding.show_save_city_search == false) {
                    this.onboardingService.showSaveCitySearchMenu();
                }
            });
        } else {
            this.router.navigate(['/app/city/result/filters']);
        }
    }

    loadSearch() {
        this.router.navigate(['/app/city/', this.userSearch.id]);
    }

    search() {
        var currentSearch: UserSearchCity = ({} as UserSearchCity);
        currentSearch.search_city_params = SEARCH_CITY_PARAMS;
        this.userService.setCurrentSearchCity(currentSearch);
        this.router.navigate(['/app/city/result/filters']);
    }

    openTuto() {
        const dialogRef = this.dialog.open(TutoComponent, {
            width: '1000px',
            maxWidth: '100%',
            data: {video: 'city_search'}
        });
    }
}
